
export default "/assets/fathom.f90c1030.svg"